import { Text } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

/**
 * Reusable styled components for empty state cards across the application.
 * Used in applications, inquiries, leases, payments, and property condition modules.
 */

export const EmptyStateTitleText = styled(Text, {
  base: {
    textStyle: { base: 'heading-xs', md: 'heading-sm' },
    marginBottom: '200',
  },
});

export const EmptyStateBodyText = styled(Text, {
  base: {
    display: 'block',
    marginBottom: '600',
  },
});
